import { Avatar, Badge, IconButton } from "@mui/material";
import React from "react";
import { MdDelete } from "react-icons/md";

function ChatList({ users, onClick, onDelete, enableDelete }) {
  return (
    <div>
      {users.map((user) => {
        return (
          <div
            className="flex w-full px-2 rounded-md gap-4 items-end justify-evenly cursor-pointer hover:bg-gray-100 active:bg-gray-200"
            onClick={() => onClick(user)}
          >
            <Avatar src={user.avatar} className="my-2" />
            <div className="flex-grow border-0 border-b border-gray-200 h-full py-2 items-start">
              <div className="flex">
                <div className="text-sm2 flex-grow"> {user.title}</div>
                <div className="text-xsm text-gray-400 px-1"> {user.date}</div>
              </div>

              <div className="flex">
                <div
                  className={
                    "text-gray-600 text-sm flex-grow" +
                    (user.subtitle ? "" : "invisible")
                  }
                >
                  {user.subtitle ?? "No Last Message"}
                </div>
                <div className="text-xsm text-gray-400 px-4">
                  <Badge badgeContent={user.unread} color="primary"></Badge>
                </div>
              </div>
            </div>

            <div
              className={
                "flex m-auto transition-[width] items-center justify-center text-center active:animate-ping " +
                (enableDelete ? "w-10 visible" : "w-0 invisible")
              }
            >
              <IconButton
                onClick={(e) => {
                  e.preventDefault();
                  onDelete(user);
                }}
              >
                <MdDelete />
              </IconButton>
            </div>
          </div>
        );
      })}
    </div>
  );
}

export default ChatList;
